import DownloadButton from "../atoms/DownloadButton";
import FormButton from "../atoms/FormButton";
import LinkButton from "../atoms/LinkButton";
import OldButtons from "../atoms/OldButtons";

import { pickDataValuesForButtonsGTM } from "../../../../utils/data.layer.utils/buttons.data.layer.util";
import { hasProperty } from "../../../../utils/validate";

const BannerButtons = ({ hasButtons, banner, category = null, slug = null, getFormData, setOpenBATD, pageData }) => {	
	return (
		<div className="buttons">
			{hasButtons &&
				banner.buttons.map(function (button, index) {
					const initialTrackingVals = pickDataValuesForButtonsGTM(category, slug, button);

					const trackingVals = {
						url: pageData.url,
						title: pageData.title,
						...initialTrackingVals,						
					};

					if (button.type === "brochure") {
						return (
							<DownloadButton key={index} button={button} trackingVals={trackingVals} />
						);
					}
					if (button.type === "form" && hasProperty(button.form, "name") && button.form.name != null) {
						return (
							<FormButton key={index} button={button} trackingVals={trackingVals} getFormData={getFormData} setOpenBATD={setOpenBATD} />
						);
					}
					if (button.type === "button") {
						return (
							<LinkButton key={index} button={button} trackingVals={trackingVals} />
						);
					}
				})}
			{!hasButtons && <OldButtons setOpenBATD={setOpenBATD} banner={banner} />}
		</div>
	);
};

export default BannerButtons;